<template>
    <div>
        <el-select 
            v-if="mode == 'edit'"
            :ref="reference"
            v-model="tmpValue"
            filterable 
            multiple 
            remote
            :placeholder="prop.placeholder ? prop.placeholder : this.$l10n.__('Rechercher')" 
            :remote-method="remoteMethod"
            :loading="loading"
            @remove-tag="remove"
            class="wp-10">
                <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.name"
                    :value="parseInt(item.id)">
                </el-option>
        </el-select>
        <p v-else>
            <ul v-if="this.selectedItems" class="list-inline">
                <li v-for="item in this.selectedItems" :key="item.id">
                    <a :href="item.url" target="_blank" class="gray-100 dinlineb">
                        {{item.name}}
                    </a>
                </li>
            </ul>
        </p>
    </div>
</template>

<script>
    import CfMixin from '../../../mixins/CustomfieldInputsMixins'
    import MultipleMixin from '../../../mixins/MultipleInputsMixins'

    export default {
        mixins: [CfMixin, MultipleMixin],
        methods: {
            remoteMethod: _.debounce(function(query) {
                if (query !== '') {
                    this.loading = true;

                    // ajax method to get staffs
                    this.$ajax.get(`/rest/catalogue/items/autocomplete`, {q: query, types: this.allowedType},
                        (response) => {
                            this.options = response
                            this.loading = false
                        },
                        (error) => {
                            this.close()
                            Push.error(this.$l10n.__("Problème lors de la récupération des données"))
                        }
                    );
                } else {
                    this.options = [];
                }
            }, 500),
            checkParams(newValue) {
                let valid = true
                valid = this.checkMinMaxParams(newValue)
                return valid
            }

        },
        computed: {
            allowedType(){
                let allowedType = []
                if(this.prop.allowedValues.length > 0){
                    this.prop.allowedValues.map(val => {
                        let typeToAdd = val.name == 'product' ? 'item' : val.name
                        allowedType.push(typeToAdd)
                    })
                }
                return allowedType
            },
            selectedItems(){
                return this.options.filter(value => this.tmpValue.includes(value.id))
            },
        }
    }
</script>
